import { Routes } from '@angular/router';
import { orientacoesTecnicasRoutes } from '@/features/solicitacoes/orientacoes-tecnicas/orientacoes-tecnicas.routes';

export const solicitacoesRoutes: Routes = [...orientacoesTecnicasRoutes];

export default solicitacoesRoutes;
